import React, { } from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'


const HomePage = () => {


    const userLogin = useSelector((state) => state.userLogin)

    return (

        <>
            {userLogin && userLogin.todoUserInfo && Object.keys(userLogin.todoUserInfo).length>0?
                <Navigate to="/todos" replace={true} /> :
                <Navigate to="/login" replace={true} />}



        </>
    )
}
export default HomePage
